document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.device-comp-scroll-btn').forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector('#is-my-device-compatible-section');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  });

  document.querySelectorAll('.select-plan-scroll-button').forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      targetId = button.getAttribute('data-url');
      const target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    });
  });

  const learnMoreButton = document.querySelector('.learn-more-button');
  const popup = document.querySelector('.learn-more__popup');
  const popupBackground = document.querySelector('.learn-more__bgr');

  function closePopup() {
    popup.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  if (learnMoreButton && popup) {
    learnMoreButton.addEventListener('click', () => {
      popup.classList.add('active');
      document.body.classList.add('no-scroll');
    });

    popupBackground?.addEventListener('click', closePopup);
  }
  document.querySelector('.learn-more__close')?.addEventListener('click', closePopup);

  const container = document.querySelector('.device-comp-scroll-btn .simify-button.open_pop-up');
});
